import { http } from "../http";

export const blogService = {
  // Fetch published blogs
  getBlogs: (params = {}) => http.get("/articles", { params }),

  // Fetch single blog by slug
  getBlogBySlug: (slug: string) => http.get(`/articles/slug/${slug}`),

  // Fetch categories
  getCategories: () => http.get("/articles/categories"),

  // Fetch tags
  getTags: () => http.get("/articles/tags"),
};
